// Yup
import { object, string } from 'yup';

import { addressSchema } from './addressSchema';

const stopSchema = object().shape({
  name: string().required('Campo nome obrigatório'),
  startLat: string()
    .required('Campo latitude inicial obrigatório')
    .matches(
      /^(\+|-)?(?:90(?:(?:\.0{1,15})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,15})?))$/g,
      { message: 'Digite uma latitude válida' },
    ),
  startLong: string()
    .required('Campo longitude inicial obrigatório')
    .matches(
      /^(\+|-)?(?:180(?:(?:\.0{1,15})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,15})?))$/g,
      { message: 'Digite uma longitude válida' },
    ),
  endLat: string()
    .required('Campo latitude final obrigatório')
    .matches(
      /^(\+|-)?(?:90(?:(?:\.0{1,15})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,15})?))$/g,
      { message: 'Digite uma latitude válida' },
    ),
  endLong: string()
    .required('Campo longitude final obrigatório')
    .matches(
      /^(\+|-)?(?:180(?:(?:\.0{1,15})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,15})?))$/g,
      { message: 'Digite uma longitude válida' },
    ),
  address: addressSchema,
});

export default stopSchema;
export { stopSchema };
